export const EVENTMODAL = 'EVENTMODAL'

export const EVENTMODAL_action = (data) => {
    return {
        type: EVENTMODAL,
        state: data
    }
}

export const GUESTSMODAL = 'GUESTSMODAL'

export const GUESTSMODAL_action = (data) => {
    return {
        type: GUESTSMODAL,
        state: data
    }
}